import { FormField, FormItem, FormLabel, FormControl, FormDescription } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Control } from "react-hook-form";

interface EmailPreferencesFieldProps {
  control: Control<any>;
  isEditing: boolean;
}

const EmailPreferencesField = ({ control, isEditing }: EmailPreferencesFieldProps) => {
  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="emailNotificationsEnabled"
        render={({ field }) => (
          <FormItem className="flex items-center justify-between space-y-0">
            <div className="space-y-0.5">
              <FormLabel className="text-sm font-medium">Email Notifications</FormLabel>
              <FormDescription className="text-xs text-muted-foreground">
                Receive email alerts for new properties matching your criteria
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={!isEditing}
              />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="notificationFrequency"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium">Notification Frequency</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
              disabled={!isEditing}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select frequency" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="instant">Instant (as properties are listed)</SelectItem>
                <SelectItem value="daily">Daily digest</SelectItem>
                <SelectItem value="weekly">Weekly summary</SelectItem>
              </SelectContent>
            </Select>
            <FormDescription className="text-xs text-muted-foreground">
              Choose how often you want to receive property notifications
            </FormDescription>
          </FormItem>
        )}
      />
    </div>
  );
};

export default EmailPreferencesField;